export const STUDENT_INFO = 'STUDENT_INFO';
export const STUDENT_INFO_ERROR = 'STUDENT_INFO_ERROR';

export const MY_ACCOMPLISHMENT = 'MY_ACCOMPLISHMENT';
export const MY_ACCOMPLISHMENT_DETAIL = 'MY_ACCOMPLISHMENT_DETAIL';